export type AttachedFileReader = (form: HTMLFormElement) => File | null;

export type ThreadActSettings = {
  sage: boolean;
  showId: boolean;
};

/** スレ立てACT欄の許可済みコマンドだけをスレッド設定へ変換する。 */
export function resolveThreadActInput(actInput: string): ThreadActSettings {
  const commands = actInput
    .trim()
    .split(/[\s,]+/u)
    .filter(Boolean)
    .map((command) => command.toLowerCase());
  return {
    sage: commands.includes("sage"),
    showId: commands.includes("id") || commands.includes("id表示"),
  };
}

/** Waits for drawing integrations and then enforces the thread image rule. */
export async function prepareThreadCreateAttachment(
  form: HTMLFormElement,
  getAttachedFile: AttachedFileReader,
): Promise<File> {
  const prepareEvent = new CustomEvent("aimg:prepare-submit", {
    detail: {} as { preparing?: Promise<void> },
  });
  form.dispatchEvent(prepareEvent);
  await prepareEvent.detail.preparing;

  const file = getAttachedFile(form);
  if (!file) throw new Error("画像を選択してください");
  return file;
}
